import { render, staticRenderFns } from "./FreesideH2.vue?vue&type=template&id=2e20bfa0&scoped=true"
import script from "./FreesideH2.vue?vue&type=script&lang=ts"
export * from "./FreesideH2.vue?vue&type=script&lang=ts"
import style0 from "./FreesideH2.vue?vue&type=style&index=0&id=2e20bfa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20bfa0",
  null
  
)

export default component.exports